import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";
import ProductCard from "@/components/ProductCard";

export default function Wishlist() {
  const { user, loading } = useAuth();
  const [items, setItems] = useState([]);

  useEffect(() => {
    if (user) api.get("/wishlist").then((r) => setItems(r.data));
  }, [user]);

  if (loading) return <div className="text-center py-32 overline">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <div data-testid="wishlist-page" className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20">
      <div className="overline">Wishlist</div>
      <h1 className="serif text-5xl mt-3 mb-12">Saved for later.</h1>
      {items.length === 0 ? (
        <p className="text-[#5A5A5A]">You haven't saved anything yet.</p>
      ) : (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-x-4 gap-y-12">
          {items.map((p, i) => <ProductCard key={p.id} product={p} idx={i} />)}
        </div>
      )}
    </div>
  );
}
